import React, { ReactNode } from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

interface DraggableProps {
  id: string;
  data: any;
  disabled: boolean;
  children: ReactNode;
}

export function DraggableComponent(props: DraggableProps) {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: props.id,
    data: props.data,
    disabled: props.disabled,
  });
  const style = {
    transform: CSS.Translate.toString(transform),
    cursor: props.disabled ? "pointer" : "default",
  };

  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
      {props.children}
    </div>
  );
}
